"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _edit = _interopRequireDefault(require("./edit.js"));
var _archive = _interopRequireDefault(require("./archive.js"));
var _loginAs = _interopRequireDefault(require("./loginAs.js"));
var _delete = _interopRequireDefault(require("./delete.js"));
var _changePassword = _interopRequireDefault(require("./changePassword.js"));
var _forgotPassword = _interopRequireDefault(require("./forgotPassword.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = {
  edit: _edit["default"],
  archive: _archive["default"],
  loginAs: _loginAs["default"],
  "delete": _delete["default"],
  changePassword: _changePassword["default"],
  forgotPassword: _forgotPassword["default"]
};